





































import { Component, Vue } from "vue-property-decorator";
import AuditTabPane from "../components/AuditTabPane.vue";
import api from "@/api";
// import {AuditUserLogType} from "@/api/appService";

@Component({
  name: "AuditTabOfCapitalIncomeRecordFromDonation",
  components: { AuditTabPane },
})
export default class AuditTabOfCapitalIncomeRecordFromDonation extends Vue {
  get fetchData() {
    return api.capitalIncomeRecordFromDonation.getMyAll;
  }

  handleAudit(dto: any) {
    return this.$router.push({
      name: "donationIncome-detail",
      params: {
        id: dto.id,
      },
    });
  }

  handleCountChange(value: number) {
    this.$emit("count-changed", value);
  }
}
